import React, { useEffect, useState } from "react";
import CustomButton from "../../../../components/common/Button/CustomButton";
import ModalSkeleton from "../../../../components/Modals/ModalSkeleton";
import { toast } from "react-toastify";
import moment from "moment";
import { checkEmail, checkPhoneNo } from "../../../../Utils/FormValidation";
import InputField from "../../../../components/common/Input/Input";
import { apiFormDataRequest } from "../../../../helpers/Requests";
import { hasBlankSpaces } from "../../../../Utils/utils";
import FileUploadInput from "../../../../components/common/FileUpload/FileUploadInput";
import { REGEX_PHONE_NUMBER } from "Constants/constant";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";

const AddNewApplicantModal = (props) => {
  const { handleClose, openModel, getApplicantsList, isUserGracePeriodOver } =
    props;

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [applicantCity, setApplicantCity] = useState("");
  const [resume, setResume] = useState("");
  const [appliedOn, setAppliedOn] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const fieldLabels = {
    firstName: "First Name",
    lastName: "Last Name",
    jobTitle: "Job Title",
    email: "Email Address",
    contact: "Phone Number",
    applicantCity: "Applicant Suburb",
    resume: "File Attachment",
    appliedOn: "Applied On",
  };

  useEffect(() => {
    if (resume && getError("resume")) {
      setErrors({ ...errors, resume: null });
    }
  }, [resume]);

  const getError = (value) => {
    if (!value) return "";
    // Return the actual error message if it exists (for custom messages like jobTitle)
    if (errors[value] && typeof errors[value] === 'string' && errors[value].length > 0) {
      if (value === "contact") {
        return "Phone number is required and must contain digits only.";
      } else {
        // Return the actual error message (e.g., "Job Title must not exceed 25 characters.")
        return errors[value];
      }
    }
    return "";
  };

  // const getError = (value) => {
  //   if (!value) return "";
  //   // return errors[value] && errors[value].length > 0 ? errors[value] : "";
  //   return errors[value] && errors[value].length > 0
  //     ? "This field is required."
  //     : "";
  // };

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (hasBlankSpaces(value) || value.length === 0) {
      const label = fieldLabels[name] || name;
      const labelLower = label.toLowerCase();
      setErrors({ ...errors, [name]: `Please enter ${labelLower}.` });
    } else if (name === "jobTitle" && value.length > 25) {
      setErrors({ ...errors, jobTitle: "Job Title must not exceed 25 characters." });
    } else if (name === "email" && value && value.length > 0) {
      const inValid = checkEmail(value);
      if (inValid) {
        setErrors({ ...errors, email: "Please enter a valid email address." });
      } else {
        setErrors({ ...errors, email: null });
      }
      return;
    } else if (errors[name] && !hasBlankSpaces(value) && value.length > 0) {
      setErrors({ ...errors, [name]: null });
    }
    if (name === "contact" && value.length > 0) {
      const inValidPhoneNo = checkPhoneNo(value);
      if (inValidPhoneNo) {
        setErrors({ ...errors, contact: "Phone number must begin with 0." });
      } else {
        setErrors({ ...errors, contact: null });
      }
    }
  };

  const handleFile = (e) => setResume(e);

  const handleClear = () => {
    setFirstName("");
    setLastName("");
    setAppliedOn(null);
    setApplicantCity("");
    setEmail("");
    setContact("");
    setJobTitle("");
    setResume("");
    setErrors({});
  };

  const handleSubmitButton = async () => {
    if (isUserGracePeriodOver) {
      return;
    }
      if(!appliedOn || appliedOn === null || appliedOn === undefined || appliedOn === "" ){
    
      toast.error("Applied date is required.")
      return
    }
    const fnError = errors;
    
    if (!firstName || firstName.length === 0) {
      Object.assign(fnError, { firstName: "Please enter first name." });
    }
    if (!lastName || lastName.length === 0) {
      Object.assign(fnError, { lastName: "Please enter last name." });
    }
    // if (!appliedOn || appliedOn.length === 0) {
    //   Object.assign(fnError, { appliedOn: "Applied On is Required" });
    // }
    if (!jobTitle || !jobTitle.length === 0) {
      Object.assign(fnError, { jobTitle: "Please enter job title." });
    }
    if (jobTitle && jobTitle.length > 25) {
      Object.assign(fnError, { jobTitle: "Job title cannot exceed 25 characters." });
    }
    if (!email || email.length <= 0 || checkEmail(email)) {
      const inValid = checkEmail(email);
      if (inValid) {
        Object.assign(fnError, { email: "Please enter a valid email address." });
      } else {
        Object.assign(fnError, { email: "Please enter email address." });
      }
    }
    if (!contact || contact.length <= 0) {
      Object.assign(fnError, { contact: "Please enter contact number." });
    }
    if (!applicantCity || applicantCity.length <= 0) {
      Object.assign(fnError, { applicantCity: "Please enter applicant suburb." });
    }
    if (!resume) {
      Object.assign(fnError, { resume: "Please upload resume." });
    }

    // console.log("fnError", fnError);
    if (
      Object.values(fnError).filter((x) => x !== null).length > 0 ||
      checkEmail(email)
    ) {
      setErrors({ ...fnError });
      return;
    }
  
    let formData = new FormData();

    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("job_type", jobTitle);
    formData.append("phone", contact);
    formData.append("city", applicantCity);
    formData.append("email", email);
    formData.append("applied_on", appliedOn);
    formData.append("resume", resume);
    // formData.append("photo", resume);

    try {
      setIsLoading(true);
      const res = await apiFormDataRequest("hrm/store/job-applicant", formData);
      if (res && res.status === 201) {
        handleClear();
        toast.success("Applicant added successfully");
        setIsLoading(false);
        getApplicantsList();
        handleClose(false);
        // setTimeout(() => navigate("/hrm/all-applicants"), 1200);
        return;
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      setError(err ? err.message : "Something went wrong");
      toast.error(err ? err.message : "Something went wrong");
    }
  };

  const modalFooter = () => (
    <>
      <CustomButton
        showLoading={isLoading}
        isDisabled={isLoading || isUserGracePeriodOver}
        label='Submit'
        clickHandler={handleSubmitButton}
      />
    </>
  );
  return (
    <ModalSkeleton
      isOpen={openModel}
      title='Add Applicant'
      cssClass={"w-[50%]"}
      modalFooter={modalFooter()}
      closeModal={() => handleClose(false)}
    >
      <div className='w-full'>
        <p className='px-2 bg-white text-sm text-gray-500'>
          Please enter following details to create new applicant
        </p>
        <div className='sm:rounded-md sm:overflow-hidden'>
          <div className='px-2 py-5 bg-white'>
            <div className='grid grid-cols-6 gap-6'>
              <div className='col-span-6 sm:col-span-3'>
                <InputField
                  label='First Name'
                  type='text'
                  // placeHolder="Enter First Name"
                  handleChange={setFirstName}
                  value={firstName}
                  ErrorMessage={getError("firstName")}
                  blurHandler={handleBlur}
                  name='firstName'
                />
              </div>
              <div className='col-span-6 sm:col-span-3'>
                <InputField
                  label='Last Name'
                  type='text'
                  // placeHolder="Enter Last Name"
                  handleChange={setLastName}
                  value={lastName}
                  ErrorMessage={getError("lastName")}
                  blurHandler={handleBlur}
                  name='lastName'
                />
              </div>
              <div className='col-span-6 sm:col-span-3'>
                <label className="text-sm font-medium text-gray-700">Applied On</label>
                  <DateRangePickerNew
                          isSingleDate
                          isClearable
                          handleCancel={()=>setAppliedOn(null)}
                          handleChange={(obj) => {
                            setAppliedOn(obj);
                          }}
                          singleSelectedDate={appliedOn && new Date(appliedOn)}
                          maxDate={new Date()}
                        />
                {/* <InputField
                  // min={moment().format("DD-MM-YYYY")}
                  label='Applied On'
                  type='date'
                  handleChange={(e) =>
                    moment(e).isAfter() ? "" : setAppliedOn(e)
                  }
                  value={appliedOn}
                  ErrorMessage={getError("appliedOn")}
                  blurHandler={handleBlur}
                  name='appliedOn'
                /> */}
              </div>

              <div className='col-span-6 sm:col-span-3'>
                <label className="text-sm font-medium text-gray-700">
                  Job Title
                </label>
                <input
                  type='text'
                  value={jobTitle}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Prevent typing beyond 25 characters
                    if (value.length > 25) {
                      setErrors({ ...errors, jobTitle: "Job Title must not exceed 25 characters." });
                      setJobTitle(value.slice(0, 25));
                    } else {
                      setJobTitle(value);
                      // Clear error if 25 or less
                      if (errors.jobTitle === "Job Title must not exceed 25 characters.") {
                        setErrors({ ...errors, jobTitle: null });
                      }
                    }
                  }}
                  onBlur={handleBlur}
                  name='jobTitle'
                  className={`mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md did-floating-input relative ${
                    errors.jobTitle === "Job Title must not exceed 25 characters." ? "errorBorder" : ""
                  }`}
                />
                {errors.jobTitle === "Job Title must not exceed 25 characters." && (
                  <span className='text-sm text-red-500 mt-1 block'>
                    {errors.jobTitle}
                  </span>
                )}
              </div>

              <div className='col-span-6 sm:col-span-3'>
                <InputField
                  label='Email Address'
                  type='email'
                  value={email}
                  // placeHolder="Enter Email Address"
                  handleChange={setEmail}
                  ErrorMessage={getError("email")}
                  name='email'
                  blurHandler={handleBlur}
                />
              </div>
              <div className='col-span-6 sm:col-span-3'>
                <InputField
                  label='Phone Number'
                  value={contact}
                  maxLength={10}
                  // placeHolder="Enter Contact"
                  pattern={REGEX_PHONE_NUMBER}
                  type='number'
                  handleChange={(e) => {
                    const sanitizedValue = e.replace(/\D/g, "");
                    const formattedValue = sanitizedValue.slice(0, 10);
                    setContact(formattedValue);
                  }}
                  ErrorMessage={getError("contact")}
                  blurHandler={handleBlur}
                  name='contact'
                />
              </div>
              <div className='col-span-6 sm:col-span-3'>
                <InputField
                  label='Applicant Suburb'
                  type='text'
                  value={applicantCity}
                  // placeHolder="Enter Applicant Suburb"
                  handleChange={setApplicantCity}
                  ErrorMessage={getError("applicantCity")}
                  blurHandler={handleBlur}
                  name='applicantCity'
                />
              </div>
            </div>
          </div>
          <div className='px-2 py-5 bg-white space-y-6'>
            <div className='col-span-2'>
              <label htmlFor='' className='did-floating-label text-start'>
                File Attachment
              </label>
              <div>
                <FileUploadInput
                  type='resume'
                  handleFile={handleFile}
                  size={10}
                  file={resume}
                  handleDelete={() => setResume("")}
                />
              </div>
              {getError("resume") && (
                <span style={{ color: "red" }}>{getError("resume")}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </ModalSkeleton>
  );
};

export default AddNewApplicantModal;
